module.exports = {"id":"204874","name":"Aleksandar Katai","rating":"74","photo":"./data/images/photos/4/204874.png","club":{"name":"Chicago Fire","logo":"./data/images/clubs/ChicagoFire.png"},"positions":["MG","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AleksandarKatai0.json
// module id = 187
// module chunks = 0